<div class="hierarchy-container">
  <span class="air-heading">TLR – Maximo – OERI Hierarchy</span>

  <div class="site-header">
    <div class="site-id">
      <span class="label">Site ID: </span>
      <span class="value">{{siteId}}</span>
    </div>
    <div class="actions">
      <button pButton label="Export To Excel" class="primary-btn h-20" (click)="exportToExcel()"></button>
    </div>
  </div>

  <div class="hierarchy-table-container">
    <!-- Main Division Table with PrimeNG -->
    <p-table class="divisions-main-table" [value]="divisions" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th class="division-header">DIVISION</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-division>
        <tr class="division-row" [ngClass]="{'expanded': division.expanded}">
          <td>
            <div class="division-item" (click)="toggleRow(division)">
              <span class="expand-icon">
                <i [ngClass]="division.expanded ? 'pi pi-minus-circle' : 'pi pi-plus-circle'"></i>
              </span>
              <span class="division-name">{{division.name}}</span>
            </div>
              <!-- Expanded Section - Nested PrimeNG Table -->
            <div *ngIf="division.expanded" class="expanded-content">              <div class="plants-scroll-container">
                <p-table [value]="division.plants" 
                        styleClass="plants-table p-datatable-sm" 
                       >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="min-width: 80px">Sec No</th>
                    <th style="min-width: 100px">Section</th>
                    <th style="min-width: 80px">Plant No</th>
                    <th style="min-width: 200px">Plant</th>
                    <th style="min-width: 120px">OERI Div</th>
                    <th style="min-width: 120px">OERI Sec</th>
                    <th style="min-width: 150px">OERI Plant</th>
                    <th style="min-width: 120px">OERI Area</th>
                    <th class="path-cell" style="min-width: 300px">OERI Loc Path</th>
                    <th style="min-width: 120px">MX Area</th>
                    <th style="min-width: 180px">MX Area Name</th>
                    <th style="min-width: 100px">MX Sec</th>
                    <th style="min-width: 180px">MX Sec Name</th>
                    <th style="min-width: 100px">MX Unit</th>
                    <th style="min-width: 180px">MX Unit Name</th>
                    <th class="path-cell" style="min-width: 300px">MX Loc Path</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-plant>
                  <tr>
                    <td style="min-width: 80px">{{plant.secNo}}</td>
                    <td style="min-width: 100px">{{plant.section}}</td>
                    <td style="min-width: 80px">{{plant.plantNo}}</td>
                    <td style="min-width: 200px">{{plant.plant}}</td>
                    <td style="min-width: 120px">{{plant.oeriDiv}}</td>
                    <td style="min-width: 120px">{{plant.oeriSec}}</td>
                    <td style="min-width: 150px">{{plant.oeriPlant}}</td>
                    <td style="min-width: 120px">{{plant.oeriArea}}</td>
                    <td class="path-cell" style="min-width: 300px" pTooltip="{{plant.oeriLocPath}}">{{plant.oeriLocPath}}</td>
                    <td style="min-width: 120px">{{plant.mxArea}}</td>
                    <td style="min-width: 180px">{{plant.mxAreaName}}</td>
                    <td style="min-width: 100px">{{plant.mxSec}}</td>
                    <td style="min-width: 180px">{{plant.mxSecName}}</td>
                    <td style="min-width: 100px">{{plant.mxUnit}}</td>
                    <td style="min-width: 180px">{{plant.mxUnitName}}</td>
                    <td class="path-cell" style="min-width: 300px" pTooltip="{{plant.mxLocPath}}">{{plant.mxLocPath}}</td>                  </tr>
                </ng-template>
              </p-table>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
